<template>
  <div class="invitation-to-organization-page">
    <OrganizationJoin :token="token" />
  </div>
</template>

<script>
  import PageTitle from '@/mixins/page-title';
  import OrganizationJoin from '@/components/blocks/reactComponents/OrganizationJoin';

  export default {
    name: 'InvitationToOrganizationPage',

    components: { OrganizationJoin },

    mixins: [PageTitle],

    data() {
      return {
        pageTitle: 'HPLC Cloud: Invitation to organization',
      };
    },

    computed: {
      token() {
        return this.$route.params.token;
      },
    },
  };
</script>
